import { CalendarIcon } from '@chakra-ui/icons';
import {
    Box,
    FormControl,
    Stack,
    FormLabel,
    InputGroup,
    InputRightElement,
} from '@chakra-ui/react';
import { SingleDatepicker } from 'chakra-dayzed-datepicker';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { useState } from 'react';

import {
    ChakraDatePickerDarkModeStyles,
    ChakraDatePickerStyles,
} from '@/chakratheme';
import { chakraDatepicker, chakraDatepickerDarkMode } from '@/constants';
import { Field } from 'formik';
import {
    formLabelStyling,
    stackStyling,
} from 'components/forms/new/formStyles';

const PreferredPortingDate = ({
    date,
    setDate,
    stateError,
    touched,
    setState,
    walkthroughId,
    darkMode,
}) => {
    const [isHovered, setIsHovered] = useState(false);
    const inputGroupStyle = {
        ...(darkMode ? chakraDatepickerDarkMode : chakraDatepicker),
        alignItems: 'center',
        '& input': {
            height: '30px',
            width: '520px',
            fontSize: '14px',
        },
    };
    return (
        <FormControl
            isRequired
            sx={{ margin: '0 !important' }}
            isInvalid={
                stateError?.['preferredPortingDate'] &&
                touched['preferredPortingDate']
            }
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" sx={stackStyling()}>
                <Box width={190}>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Preferred Porting Date
                    </FormLabel>
                </Box>
                <Field
                    component={() => (
                        <InputGroup
                            mt="13px"
                            sx={inputGroupStyle}
                            data-walkthroughid={walkthroughId}>
                            <SingleDatepicker
                                name="date-input"
                                date={date}
                                onDateChange={(value) => {
                                    const newDate = new Date(value);
                                    newDate.setHours(0, 0, 0, 0);

                                    setState({
                                        preferredDate: newDate,
                                    });
                                    setDate(newDate);
                                }}
                                configs={{
                                    dateFormat: ' ccc, dd MMM, yyyy zzz',
                                }}
                                propsConfigs={
                                    darkMode
                                        ? ChakraDatePickerDarkModeStyles
                                        : ChakraDatePickerStyles
                                }
                                minDate={new Date()}
                            />
                            <InputRightElement
                                color={darkMode ? 'white' : 'gray.500'}
                                pointerEvents="none"
                                top="unset"
                                right="10%">
                                <CalendarIcon />
                            </InputRightElement>
                        </InputGroup>
                    )}
                    name="preferredPortingDate"
                    id="preferredPortingDate"
                    width={520}
                />

                {isHovered && (
                    <FieldToolTip
                        label="Date you would like the port to complete"
                        ariaLabel="preferredPortingDate-tip"
                        right="25px"
                        top="23px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default PreferredPortingDate;
